export default "__VITE_ASSET__C_hmolZ2__"